import React, {Component} from 'react'
import {Router} from "config/routes";
import {getAuthenticator} from '../services/Authenticator';

const AuthContext = React.createContext();

export default class extends Component {
    state = {
        loading: true,
        user: null,
        email: null
    };

    componentDidMount() {
        getAuthenticator().then(Authenticator => Authenticator.getUser()
            .then((user) => {
                this.setState({loading: false, user: user})
            })
            .catch(() => {
                this.setState({loading: false, user: null});
            })
            .finally(() => {
                this.refreshEmail();
            })
        );
    }

    logout() {
        return getAuthenticator().then(Authenticator => Authenticator.logout()
            .then(() => {
                this.setState({user: null}, () => {
                    this.refreshEmail();
                });
            })
            .catch());
    }

    login(username, password) {
        return getAuthenticator().then(Authenticator => Authenticator.login(username, password)
            .then((user) => {
                this.setState({user: user}, () => {
                    this.refreshEmail();
                });
            }));
    }

    signup(username, email, password) {
        return getAuthenticator().then(Authenticator => Authenticator.signup(username, email, password)
            .then((user) => {
                this.setState({user: user}, () => {
                    this.refreshEmail();
                })
            }));
    }

    setEmail(email) {
        getAuthenticator().then((Authenticator) => {
            Authenticator.setEmail(email);
            this.refreshEmail();
        });
    }

    refreshEmail() {
        getAuthenticator().then(Authenticator => Authenticator.getEmail()
            .then((email) => {
                this.setState({email: email});
            }));
    }

    changePassword(currentPassword, newPassword) {
        return getAuthenticator().then(Authenticator => Authenticator.changePassword(currentPassword, newPassword));
    }

    render() {
        return <AuthContext.Provider
            value={{
                authLoading: this.state.loading,
                user: this.state.user,
                email: this.state.email,
                login: this.login.bind(this),
                logout: this.logout.bind(this),
                signup: this.signup.bind(this),
                setEmail: this.setEmail.bind(this),
                changePassword: this.changePassword.bind(this),
            }}
        >
            {this.props.children}
        </AuthContext.Provider>;
    }
}

const withAuthentication = (WrappedComponent) => {
    return ({...props}) => {
        return <AuthContext.Consumer>
            {({user, email, login, logout, signup, setEmail, changePassword, authLoading}) => {
                return <WrappedComponent user={user} email={email} login={login} logout={logout}
                                         signup={signup} setEmail={setEmail} changePassword={changePassword}
                                         authLoading={authLoading} {...props}/>
            }}
        </AuthContext.Consumer>
    }
};

const withAuthenticationRequired = (WrappedComponent) => {
    return ({...props}) => {
        if (props.authLoading) {
            return <div/>
        }

        if (props.user) {
            return <WrappedComponent {...props}/>
        } else {
            Router.pushRoute('login', {redirect_to: window.location.href});
            return <div/>
        }
    }
};

export {withAuthentication, withAuthenticationRequired};
